"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Record = void 0;
/**
 * List of ANS Records
 */
var Record;
(function (Record) {
    Record["IPFS"] = "IPFS";
    Record["ARWV"] = "ARWV";
    Record["SOL"] = "SOL";
    Record["ETH"] = "ETH";
    Record["BTC"] = "BTC";
    Record["LTC"] = "LTC";
    Record["DOGE"] = "DOGE";
    Record["Email"] = "email";
    Record["Url"] = "url";
    Record["Discord"] = "discord";
    Record["Github"] = "github";
    Record["Reddit"] = "reddit";
    Record["Twitter"] = "twitter";
    Record["Telegram"] = "telegram";
    Record["Pic"] = "pic";
    Record["SHDW"] = "SHDW";
    Record["POINT"] = "POINT";
})(Record = exports.Record || (exports.Record = {}));
//# sourceMappingURL=records.js.map